import { render, staticRenderFns } from "./entertainment_form.vue?vue&type=template&id=2b10445c"
import script from "./entertainment_form.vue?vue&type=script&lang=js"
export * from "./entertainment_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports